
export class EventSessionBookingFail {
     
    constructor(data) {       

        this.session = data && data.session ? data.session : undefined;  
        this.reason = data && data.reason ? data.reason : ''; 
        this.result = data && data.result !== undefined ? data.result : false;
    }
}